﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import axios from 'axios'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './styles/theme.css'   // 自定义主题（在 Element Plus 之后，覆盖默认样式）
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import router from './router'

// 全局 dayjs 中文（影响所有 dayjs().format() 输出和日期选择）
dayjs.locale('zh-cn')

// 将 createApp(App) 的返回值赋给 app 变量
const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })  // Element Plus 全局中文
app.use(router)
app.config.globalProperties.$axios = axios

const pinia = createPinia();
app.use(pinia);
app.mount('#app')
window.addEventListener('error', (event) => {
    if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
    }
  });
